function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "calendar",
  transform: "translate(-2.4 -1.167)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_577",
  "data-name": "Ret\\xE2ngulo 577",
  width: 14,
  height: 14,
  rx: 2,
  transform: "translate(3 3.767)",
  fill: "none",
  stroke: "#848484",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2
}), /*#__PURE__*/React.createElement("line", {
  id: "Linha_29",
  "data-name": "Linha 29",
  y2: 3,
  transform: "translate(13 1.767)",
  fill: "none",
  stroke: "#848484",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2
}), /*#__PURE__*/React.createElement("line", {
  id: "Linha_30",
  "data-name": "Linha 30",
  y2: 3,
  transform: "translate(7 1.767)",
  fill: "none",
  stroke: "#848484",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2
}), /*#__PURE__*/React.createElement("line", {
  id: "Linha_31",
  "data-name": "Linha 31",
  x2: 14,
  transform: "translate(3 8.767)",
  fill: "none",
  stroke: "#848484",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2
}));

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.2,
    height: 17.2,
    viewBox: "0 0 15.2 17.2",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.4911dba3.svg";
export { ForwardRef as ReactComponent };